export const g_countryCode = "106";
export const g_Failed = "Currently service is down. Please try after sometime.";
export const g_OtpError = "Invalid OTP";
export const g_teamMemberOnly = "1A";
export const g_teamMemberFamily = "2A+2C";
export const g_invalidEmpCount = "Employees range can be from 2 to 10,000"
